import React, { useState } from 'react';
import { addManualTask } from '../services/manualTasks';

// "+ Add task" for a client: title, due date + time, optional note, priority.
// Saves a Manual task linked to the contact and, where given, to the deal or the buyer/seller interest.
// Deal tasks go on the deal (owner + co-agents see them); all others go to users/{uid}/tasks. No notifications.
const todayISO = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; };
const input = { padding: '8px 10px', border: '1px solid #ccc', borderRadius: 6, fontSize: 14, boxSizing: 'border-box', minWidth: 0 };
const btn = { padding: '8px 14px', background: '#B8962E', color: '#fff', border: 'none', borderRadius: 6, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' };

export default function AddClientTask({ uid, contactId, contactName, transactionId, buyerInterestId, sellerInterestId, startOpen = false, hint, onAdded, disabled }) {
  const [open, setOpen] = useState(startOpen);
  const [title, setTitle] = useState('');
  const [dueDate, setDueDate] = useState(todayISO());
  const [dueTime, setDueTime] = useState('');
  const [notes, setNotes] = useState('');
  const [priority, setPriority] = useState('medium');
  const [err, setErr] = useState('');
  const [ok, setOk] = useState('');
  const [busy, setBusy] = useState(false);

  if (!open) {
    return <button type="button" style={{ ...btn, background: '#fff', color: '#B8962E', border: '1px solid #B8962E' }} disabled={disabled || !uid} onClick={() => { setOpen(true); setOk(''); }}>+ Add task</button>;
  }
  const save = async () => {
    if (!title.trim()) { setErr('Add a task title.'); return; }
    if (!dueDate) { setErr('Pick a due date.'); return; }
    setErr(''); setBusy(true);
    try {
      const res = await addManualTask({ uid, title, dueDate, dueTime, notes, priority, contactId, contactName, transactionId, buyerInterestId, sellerInterestId });
      setTitle(''); setNotes(''); setDueTime(''); setDueDate(todayISO()); setPriority('medium');
      setOk('Task added.');
      if (!startOpen) setOpen(false);
      onAdded && onAdded(res);
    } catch (e) { setErr(`Not saved: ${e?.message || 'something went wrong'}.`); } finally { setBusy(false); }
  };
  return (
    <div style={{ padding: 10, border: '1px solid #e5e5e5', borderRadius: 8, background: '#fff' }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        <input style={{ ...input, flex: '2 1 200px' }} placeholder="Task, e.g. Call back about showings" value={title} onChange={(e) => setTitle(e.target.value)} aria-label="Task title" />
        <input style={{ ...input, flex: '1 1 140px' }} type="date" value={dueDate} onChange={(e) => setDueDate(e.target.value)} aria-label="Due date" />
        <input style={{ ...input, flex: '1 1 110px' }} type="time" value={dueTime} onChange={(e) => setDueTime(e.target.value)} aria-label="Time (optional)" title="Time (optional)" />
        <select style={{ ...input, flex: '1 1 110px' }} value={priority} onChange={(e) => setPriority(e.target.value)} aria-label="Priority">
          <option value="high">High priority</option><option value="medium">Medium priority</option><option value="low">Low priority</option>
        </select>
      </div>
      <textarea style={{ ...input, width: '100%', marginTop: 8, minHeight: 50 }} placeholder="Note (optional)" value={notes} onChange={(e) => setNotes(e.target.value)} />
      {err && <div role="alert" style={{ color: '#d32f2f', fontWeight: 700, marginTop: 6 }}>{err}</div>}
      {ok && <div style={{ color: '#1E6B43', fontWeight: 700, marginTop: 6 }}>{ok}</div>}
      <div style={{ display: 'flex', gap: 8, marginTop: 8, flexWrap: 'wrap' }}>
        <button type="button" style={btn} disabled={busy} onClick={save}>{busy ? 'Adding...' : 'Add task'}</button>
        {!startOpen && <button type="button" style={{ ...btn, background: '#eee', color: '#333' }} onClick={() => setOpen(false)}>Cancel</button>}
      </div>
      <div style={{ fontSize: 12, color: '#5B6270', marginTop: 4 }}>{hint || 'Goes on your Tasks list as a Manual task, linked to this client.'}</div>
    </div>
  );
}
